import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CrossBorderWithdrawalInfo from './CrossBorderWithdrawalInfo';
import useFetchCrossBorderTransactions from '@/hooks/useApi/useFetchCrossBorderTransactions';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type DataProps = {
  transactionId: string;
  activeModule: string;
  hasNewTransactionButton: boolean;
  accountId: string;
};

type CrossBorderWithdrawalProps = {
  transactionId: string;
  notes: string;
  jwt: string;
};

type FC = FunctionComponent<CrossBorderWithdrawalProps>;

const EftWithdrawTransactionContainer: FC = ({ transactionId, notes, jwt }: CrossBorderWithdrawalProps) => {
  const { state } = useLocation<DataProps>();

  const { userSettings } = useUserSettingsProvider();
  const { transactions, fetchTransactions } = useFetchCrossBorderTransactions({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.GlobalSendRecentTransaction>();

  useEffect(() => {
    fetchTransactions({
      ClientAccountID: state?.accountId,
      TransactionID: transactionId,
      Timezone: userSettings.timezone,
    });
  }, [currentTransactionId, transactionId, state?.accountId]);

  useEffect(() => {
    if (transactions) {
      const transaction = transactions.find((t) => t.TransactionID === transactionId);
      setTransaction(transaction);
    }
  }, [transactions]);

  if (currentTransactionId !== transactionId) {
    setCurrentTransactionId(transactionId);
  }

  return <div>{transaction && <CrossBorderWithdrawalInfo transaction={transaction} notes={notes} jwt={jwt} />}</div>;
};

export default EftWithdrawTransactionContainer;
